import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const hotelSwiperEls = document.querySelectorAll('.hotel-swiper');

hotelSwiperEls.forEach((el) => {
  const totalSlides = el.querySelectorAll('.swiper-slide').length;
  const canAutoPlay = totalSlides > 1;

  const swiperConfig = {
    modules: [],
    slidesPerView: 1,
    loop: canAutoPlay,
  };

  if (canAutoPlay) {
    swiperConfig.modules.push(Autoplay);
    swiperConfig.autoplay = {
      delay: 3500,
      disableOnInteraction: false,
    };
  }

  new Swiper(el, swiperConfig);
});
